import { FormEvent, useState } from "react";
import { api } from "../api";

export function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setMessage("");
    try {
      await api("/api/session", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      const next = new URLSearchParams(window.location.search).get("next");
      window.location.assign(next?.startsWith("/") ? next : "/");
    } catch (error) {
      setMessage(error instanceof Error ? error.message : "Não foi possível entrar.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login-shell">
      <section className="login-brand">
        <img className="login-wordmark" src="/brand/asterum-wordmark-tagline.svg" alt="Asterum Beyond Intelligence" />
        <div className="login-token-wrap"><span /><img src="/brand/aster-token.png" alt="Token ASTER" /></div>
        <p>Performance que você pode verificar.</p>
      </section>
      <section className="login-card">
        <span className="eyebrow">Acesso privado</span>
        <h1>ASTER Network</h1>
        <p>Entre com suas credenciais para acompanhar os fechamentos realizados.</p>
        <form onSubmit={submit}>
          <label><span>Usuário</span><input autoComplete="username" value={username} onChange={(event) => setUsername(event.target.value)} required /></label>
          <label><span>Senha</span><input type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} required /></label>
          {message && <div className="status-message error">{message}</div>}
          <button className="primary-button login-button" disabled={busy}>{busy ? "Validando…" : "Entrar na rede"}</button>
        </form>
        <small>Conexão protegida | sessão criptografada | acesso individual</small>
      </section>
    </main>
  );
}
